import React from 'react';
import type {ViewStyle} from 'react-native';

import {Bone} from './Bone';

type BoneIconProps = {
  size?: number;
  animationDelay?: number;
  style?: ViewStyle;
  testID?: string;
};

export const BoneIcon: React.FC<BoneIconProps> = React.memo(({size = 24, ...rest}) => (
  <Bone width={size} height={size} borderRadius={size / 2} {...rest} />
));
BoneIcon.displayName = 'BoneIcon';
